export default __webpack_public_path__ + "static/media/down-arrow-big.e162d929.svg";